import {
  editMode,
  forceChoosePaymentOnlyAndSubmit,
  forceHidePreviousSteps,
  forceNoOrder,
  forceNoSendToDevice,
  forcePaymentOnly,
  forceShowOrderStep,
  openNextStepOnInit,
  setDemo,
} from './functions';

export const PARAM_HANDLER = {
  forceNoOrder,
  forceNoSendToDevice,
  forcePaymentOnly,
  forceChoosePaymentOnlyAndSubmit,
  editMode,
  openNextStepOnInit,
  forceHidePreviousSteps,
  setDemo,
  forceShowOrderStep,
};
